import { render, staticRenderFns } from "./TuitionTable.vue?vue&type=template&id=372bffb0&"
import script from "./TuitionTable.vue?vue&type=script&lang=js&"
export * from "./TuitionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports